// src/services/featuredVideo.service.ts
import api from '../lib/api';

const API_URL = import.meta.env.VITE_API_URL;

// =============================
// GET FEATURED VIDEO (upload or YouTube)
// =============================
export async function fetchFeaturedVideo() {
  try {
    const res = await api.get(`${API_URL}/api/featured-video`);
    return res.data; // { videoUrl: string, source: "youtube" | "upload" }
  } catch (err) {
    console.error('Error loading featured video:', err);
    throw err;
  }
}
